import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { tap, pluck } from 'rxjs/operators';
import * as ErrorActions from './actions';
import { UnexpectedError } from './data/models/unexpected-error.model';

@Injectable()
export class ErrorEffects {
    constructor(private actions$: Actions) {}

    @Effect({ dispatch: false })
    showUnexpectedError$: Observable<any> = this.actions$.pipe(
        ofType(ErrorActions.ActionTypes.SHOW_UNEXPECTED_ERROR),
        pluck('payload'),
        tap((err) => {
            throw new UnexpectedError(err);
        })
    );
}
